<ion-content class="ion-padding ion-align-items-center">
    <ion-item lines="none" class="ion-align-self-center">
        <ion-label class="ion-text-wrap"><h4>{{ loadingMsg }}</h4></ion-label>
        <ion-spinner slot="start" name="bubbles"></ion-spinner>
    </ion-item>
    <ion-progress-bar class="ion-padding-horizontal" [value]="progress"></ion-progress-bar>
</ion-content>
